import React, { useEffect, useState } from 'react';
import { Spinner } from 'reactstrap';
import { getAuthToken } from '../../../../auth/tokenvalidation';
import {
  isLpgProduct,
  requiresLpgCargoRatioSelection,
  usesDyedUndyedAlpha,
  getAlphaColumnLabel,
  getProcurementProductNameId,
  getProcurementProductTypeId,
  fetchProductTypePricingUnit,
} from '../../../TenderOpening/utils/tenderOpeningHelpers';
import HpsParcelNonLpg from './nonLpg/HpsParcelNonLpg';
import HpsParcelLpg from './lpg/HpsParcelLpg';

const HpsParcelSection = ({
  parcels = [],
  isLoadingParcels = false,
  procurement,
  isReadOnly = false,
  onCargoRatioStatusChange,
  cargoRatioErrorParcelId = null,
  onClearCargoRatioError,
}) => {
  const [pricingUnit, setPricingUnit] = useState(null);
  const isLpg = isLpgProduct(procurement);
  const productNameId = getProcurementProductNameId(procurement);
  const usesDyedUndyed = usesDyedUndyedAlpha(productNameId);
  const quantityUnitLabel =
    procurement?.productType?.unit || (isLpg ? 'MT' : 'MB');

  useEffect(() => {
    if (isLpg || usesDyedUndyed) {
      setPricingUnit(null);
      return;
    }
    const productTypeId = getProcurementProductTypeId(procurement);
    const token = getAuthToken();
    let cancelled = false;
    fetchProductTypePricingUnit(productTypeId, token).then(unit => {
      if (!cancelled) setPricingUnit(unit);
    });
    return () => {
      cancelled = true;
    };
  }, [isLpg, usesDyedUndyed, procurement]);

  if (isLoadingParcels) {
    return (
      <div className='text-center py-4'>
        <Spinner size='sm' color='primary' />
        <p className='text-muted small mt-2 mb-0'>Loading parcels...</p>
      </div>
    );
  }

  if (!parcels.length) {
    return <p className='text-muted small mb-0'>No parcel data available.</p>;
  }

  if (isLpg) {
    return (
      <HpsParcelLpg
        parcels={parcels}
        procurementId={procurement?.id}
        quantityUnitLabel={quantityUnitLabel}
        requiresCargoRatio={requiresLpgCargoRatioSelection(procurement)}
        isReadOnly={isReadOnly}
        onCargoRatioStatusChange={onCargoRatioStatusChange}
        cargoRatioErrorParcelId={cargoRatioErrorParcelId}
        onClearCargoRatioError={onClearCargoRatioError}
      />
    );
  }

  return (
    <HpsParcelNonLpg
      parcels={parcels}
      quantityUnitLabel={quantityUnitLabel}
      usesDyedUndyed={usesDyedUndyed}
      alphaColumnLabel={getAlphaColumnLabel(pricingUnit)}
    />
  );
};

export default HpsParcelSection;
